import { render, staticRenderFns } from "./ClosedSalesRow.vue?vue&type=template&id=4cb2e10c"
import script from "./ClosedSalesRow.vue?vue&type=script&lang=js"
export * from "./ClosedSalesRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports